import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"

export function otc_auth_status(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_otc/otc_auth_status`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function get_persional_info(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_otc/get_persional_info`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function get_auth_info(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_otc/get_auth_info`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function get_bank_account(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_otc/get_bank_account`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function get_additional_info(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account_otc/get_additional_info`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function get_info(url, params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}${url}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_info(url, params) {
    return new Promise((resolve, reject) => {
        postJson(`${url_domain()}${url_pre()}${url}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_persional_info(params) {
    return new Promise((resolve, reject) => {
        postJson(`${url_domain()}${url_pre()}/account_otc/att_persional_info`, params)
            .then((res) => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_auth_info(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_otc/att_auth_info`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_bank_account(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_otc/att_bank_account`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function att_additional_info(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/account_otc/att_additional_info`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// export function createApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/create`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

// export function destroyApi(params) {
//     return new Promise((resolve, reject) => {
//         postJson(`${url_domain()}${url_pre()}/security/merchant_api/destroy`, params)
//             .then(res => {
//                 if (res.code == 0) {
//                     resolve(res.data)
//                 }
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

